import React, { useContext, useEffect, useState } from 'react'
import { Button, Card, Space, Table } from 'antd'
import useSWR from 'swr'
import { useToken } from '../../../../../hooks'
import API from '../../../../../../utils/api'
import { ReloadOutlined } from '@ant-design/icons'
import { ThemeContext } from '../../../../../../theme/ThemeProvider'

const PGTableAPI = ({
	title,
	apikey,
	columns,
	width = 1400,
	height = 'default',
	usermodal = false,
	className = undefined,
	footer = 0,
}: any) => {
	const { data: token } = useToken()
	const [page, setPage] = useState(1)
	const [maxData, setMaxData] = useState(50)
	const [showModal, setShowModal] = useState(false)
	const [selectedData, setSelectedData] = useState<any>(null)

	// API 키에서 기본 파라미터 추출하여 새로운 파라미터와 합치기
	const finalApiKey = apikey ? `${apikey}&maxData=${maxData}&page=${page}` : null

	const { data, mutate, isLoading, isValidating } = useSWR<any>(
		finalApiKey,
		async (url: string) => {
			const response = await API.get(url, token + '', {}, false)
			console.log('PG API Response:', response)
			
			// 새로운 API 응답 구조를 기존 TableAPI 구조로 변환
			if (response?.result?.data) {
				return {
					list: response.result.data, // data 배열을 list로 변환
					totalCount: response.result.total || 0 // total을 totalCount로 변환
				}
			}
			
			return { list: [], totalCount: 0 }
		},
		{ revalidateOnFocus: false, dedupingInterval: 0 }
	)

	const dataSource = data?.list || []

	const footerTable = footer > 0 ? () => {
		return (
			<div style={{ padding: '8px 16px', background: '#fafafa' }}>
				<Space>
					<span>총 {data?.totalCount || 0}건</span>
				</Space>
			</div>
		)
	} : undefined

	return (
		<Card
			title={title}
			extra={
				<Space>
					<Button
						icon={<ReloadOutlined />}
						onClick={() => mutate()}
						size="small">
						새로고침
					</Button>
				</Space>
			}
			size="small"
			style={{
				width: '100%',
				height: '100%',
				margin: 0,
				padding: 0,
			}}>
			<Table
				rowKey={(record, index) => 'KEY' + index + '-' + (record.id || record.user_id)}
				rootClassName={className ? className : ''}
				bordered={true}
				pagination={{
					current: page,
					total: data?.totalCount || 0,
					pageSize: maxData,
					pageSizeOptions: ['20', '50', '100', '200'],
					onShowSizeChange: (current, size) => {
						setMaxData(size)
						setPage(1)
					},
					onChange: page => setPage(page),
				}}
				footer={footerTable}
				dataSource={dataSource}
				columns={columns(
					mutate,
					data => {
						setSelectedData(data)
						setShowModal(true)
					}
				)}
				scroll={
					!height || height == 'default'
						? { x: width }
						: { x: width, y: height }
				}
				size="small"
				loading={isLoading || isValidating}
				style={{
					width: '100%',
					padding: 0,
				}}
			/>
		</Card>
	)
}

export default React.memo(PGTableAPI)
